import React from 'react';
import { Row } from 'react-bootstrap';
import { CaseDetailSidebarPatientInfo, CaseDetailSidebarNav } from '.';
import './CaseDetailSidebar.scss';
import { PatientDetailSideBarNav } from './PatientDetailSidebarNav';
import { useParams } from 'react-router';

interface PrimarySidebarParams {
  id: string;
}

const PrimarySidebar = () => {
  const { id: urlId } = useParams<PrimarySidebarParams>();
  return (
    <Row>
      <CaseDetailSidebarPatientInfo id={urlId} />
      <PatientDetailSideBarNav />
    </Row>
  );
};
export default PrimarySidebar;
